import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { SubscriptionEstimationApi, SubscriptionEstimationFeatureTranslation } from "../../../api/types";
import { Loading } from "../../Loading";
import SubscriptionBasedRestrictionHeaderModal from "./SubscriptionBasedRestrictionHeaderModal";
import SubscriptionBasedRestrictionModalPlanInfoCard from "./SubscriptionBasedRestrictionModalPlanInfoCard";

interface Props {
	show: boolean;
	onHide: () => void;
	featureId: string;
	limit?: number;
	name: string;
	property: number | string | boolean;
	resource?: string;
	featureTranslations: SubscriptionEstimationFeatureTranslation[];
	accountsUrl: string;
	companyId: string;
	getSubscriptionsEstimate: (
		featureId: string,
		params?: Record<string, any>,
		options?: Record<string, any>
	) => Promise<SubscriptionEstimationApi>;
}

const SubscriptionBasedRestrictionModal = ({
	onHide,
	show,
	featureId,
	limit,
	name,
	property,
	resource,
	featureTranslations,
	accountsUrl,
	companyId,
	getSubscriptionsEstimate,
}: Props) => {
	const [subscriptionEstimation, setSubscriptionEstimation] = useState<SubscriptionEstimationApi | undefined>();
	const { addFlash } = useFlash();

	useEffect(() => {
		fetchSubscriptionEstimation();
	}, []);

	const fetchSubscriptionEstimation = async () => {
		try {
			const res = await getSubscriptionsEstimate(featureId);
			setSubscriptionEstimation(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	return (
		<Modal onHide={onHide} show={show} className="subscription-based-restriction-modal">
			{subscriptionEstimation && (
				<SubscriptionBasedRestrictionHeaderModal
					featureEstimate={subscriptionEstimation}
					featureLimit={limit}
					featureName={name}
					organizationProperty={property}
					resource={resource}
				/>
			)}
			<Modal.Body className={`${subscriptionEstimation ? "mt-0" : "mt-4"}`}>
				{subscriptionEstimation ? (
					<SubscriptionBasedRestrictionModalPlanInfoCard
						estimatedFeature={subscriptionEstimation}
						featureId={featureId}
						featureTranslations={featureTranslations}
						accountsUrl={accountsUrl}
						companyId={companyId}
					/>
				) : (
					<Loading />
				)}
			</Modal.Body>
		</Modal>
	);
};

export default SubscriptionBasedRestrictionModal;
